import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ToastrService } from '@shared/services/toastr.service';
import { ConfirmService } from '@shared/services/confirm.service';
import { ADD_ROUTE } from '../../../app-routing.constants';
import { ColumnMode } from '@siemens/ngx-datatable';
import {
  CustomPagesProfileModel,
  OrganizationCustomPagesProfileService,
} from '@shared/services/custom-page-profiles/organization-custom-pages-profile.service';
import { ERROR_CODE } from '@shared/enums/errors/ErrorCodes';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { NgFor, NgIf } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateFormatPipe } from '@shared/pipe/filter.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { ClipboardService } from '@shared/services/clipboard.service';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';

@Component({
  selector: 'app-custom-pages-profiles',
  templateUrl: './custom-pages-profiles.component.html',
  styleUrl: './custom-pages-profiles.component.scss',
  imports: [NgIf, NgFor, RouterLink, NgxPaginationModule, DateFormatPipe, TranslatePipe, BadgeOrganizationComponent],
})
export class CustomPagesProfilesComponent implements OnInit, OnDestroy {
  ColumnMode = ColumnMode;
  customPagesProfileModels: CustomPagesProfileModel[] = [];
  nbCustomPagesProfileModels = 0;
  page = 0;
  size = 10;

  search = '';
  private search$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private organizationCustomPagesProfileService: OrganizationCustomPagesProfileService,
    private toastr: ToastrService,
    private confirmService: ConfirmService,
    private clipboard: ClipboardService,
  ) {}

  ngOnInit() {
    this.search$.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(() => {
      this.page = 0;
      this.loadCustomPagesProfiles();
    });

    this.loadCustomPagesProfiles();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearch(term: string) {
    this.search$.next(term ?? '');
  }

  addCustomPagesProfile() {
    this.router.navigate(['custom-pages-profiles', ADD_ROUTE], { relativeTo: this.route });
  }

  deleteCustomPagesProfile(customPagesProfileModel: CustomPagesProfileModel) {
    this.confirmService.confirm(
      {
        html: 'Supprimer cette personnalisation des erreurs ?',
      },
      () =>
        this.organizationCustomPagesProfileService
          .removeCustomPagesProfiles(customPagesProfileModel.uid)
          .subscribe(() => {
            this.loadCustomPagesProfiles();
            this.toastr.success();
          }),
    );
  }

  changePage(e: number) {
    this.page = e - 1;
    this.loadCustomPagesProfiles();
  }

  loadCustomPagesProfiles() {
    const search = this.search?.trim() || undefined;

    this.organizationCustomPagesProfileService
      .getCustomPagesProfiles({ number: this.page, size: this.size, search })
      .subscribe((res) => {
        this.customPagesProfileModels = res.content;
        this.nbCustomPagesProfileModels = res.totalElements;
      });
  }

  getErrors(row: CustomPagesProfileModel): string {
    const configured: string[] = [];
    if (row.originErrorTemplate) {
      configured.push(ERROR_CODE.SERVER_ERROR);
    }
    if (row.blockedTemplate) {
      configured.push(ERROR_CODE.FORBIDDEN);
    }
    if (row.challengeTemplate) {
      configured.push(ERROR_CODE.CHALLENGE);
    }
    return configured.join(', ');
  }
}
